import "./Modal.css";

const Modal = ({ children, isOpen, closeModal, max, min, closeOnBackdrop = true }) => {
  const handleModalContainerClick = (e) => e.stopPropagation();
  const handleBackdropClick = () => {
    if (closeOnBackdrop) closeModal();
  };

  return (
    <article className={`modal ${isOpen && "is-open"}`} onClick={handleBackdropClick}>
      <div className={max ? "modal-container-max" : (min ? "modal-container-min" : "modal-container")} onClick={handleModalContainerClick}>
        <button type="button" className="modal-close btn btn-danger" onClick={closeModal} style={{border: "none"}}>X</button>
        {children}
      </div>
    </article>
  );
};

export default Modal;